import React from 'react'

import latest1 from "../images/latest1.webp"
import { Link } from 'react-router-dom'

function Mainproduct({ id, image, name, price }) {
    return (
        <>
            <Link className='mainproductmaindiv' style={{width:"100%"}} to={`/product/${id}`} >
                <div className='shopproductimgdiv'>
                    <img src={image[0]} className='shopproductimg' alt="sliderimg" />
                </div>
            </Link>
        </>
    )
}

export default Mainproduct
